import { useEffect } from 'react';
import type { ResponsePayload } from '../../../types';
import { registerQuestionRenderer, type QuestionRendererComponent } from './registry';

const DisplayOnlyRenderer: QuestionRendererComponent = ({
  question,
  existingResponse,
  onDraftChange,
  onHasUserInputChange,
  onValidityChange,
  onExtrasChange,
}) => {
  void onExtrasChange;
  const questionId = question?.id ?? existingResponse?.question ?? -1;

  useEffect(() => {
    onHasUserInputChange?.(false);
    onValidityChange?.(true);

    if (questionId < 0) {
      onDraftChange(null);
      return;
    }

    const payload: ResponsePayload = {
      question: questionId,
    };

    onDraftChange(existingResponse ?? payload);
  }, [
    existingResponse,
    onDraftChange,
    onHasUserInputChange,
    onValidityChange,
    questionId,
  ]);

  return null;
};

registerQuestionRenderer(['description', 'image'], DisplayOnlyRenderer);
